module.exports = __webpack_public_path__ + "static/img/icon_bmks.f4528fe1.png";